import {NgModule} from "@angular/core";
import {InputMaskDirective} from "./inputMask.directive";
import {CommonModule} from "@angular/common";
import {NControlsModule} from "n-framework/n-controls";

@NgModule({
  declarations: [
    InputMaskDirective
  ],
  imports: [
    CommonModule,
    NControlsModule
  ],
  exports: [
    InputMaskDirective
  ],
  providers: [],
  entryComponents: []
})

export class NInputMaskModule {
}
